export default __webpack_public_path__ + "static/media/Order.e182e61a.svg";